var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BrAside'),_c('v-main',{staticClass:"container-gestao overflow-hidden"},[_c('div',{staticClass:"wrapper overflow-y-auto",attrs:{"id":"scrolling"}},[_c('v-container',{staticClass:"main-container",attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in","appear":""}},[_c('router-view')],1)],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }